






















































































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import VWidget from '@/components/VWidget.vue';
import Util from '@/lib/util';
import ListBase from '@/lib/listbase';
import Fee from '@/store/entities/casis/fee';


@Component({
    components: { VWidget },
    watch: {
        dealers: function (val) {
            (this as any).loadData();
        },
        red: function (val) {
            (this as any).loadData();
        }
    }
})

export default class FeeForm extends ListBase {
    period: any = parseInt(Util.abp.clock.today().substr(0, 4));
    changed: boolean = false;
    //fee: Fee = new Fee();
    listValues: Array<any> = new Array<any>();
    totals: Array<any> = new Array<any>();
    
    /***** computed methods *****/
    get loading() {
        return this.$store.state.fee.loading;
    }

    get list() {
        return this.$store.state.fee.list;
    }

    get periods() {
        return this.gCommonList('years');
    }

    get months() {
        let list = this.gCommonList('months');
        list.forEach(m => {
            m['field'] = 'month_' + m.id;
        });
        return list;
    }

    get groups() {
        return Util.abp.list.getList('G_FEE');
    }

    get dealers() {
        return this.$store.state.app.dealers;
    }

    get dealer() {
        return this.$store.state.app.dealer;
    }
           
    get red() {
        return this.$store.state.app.red;
    }

    get fee() {
        if (this.list[0] == undefined) return null;
        if (this.list[0].fee_id == null) return null;
        return {
            id: this.list[0].fee_id,
            month: this.list[0].fee_month,
            published: this.list[0].fee_published,
        };
    }

    get lastMonth() {
        if (this.fee == null) {
            let curr = parseInt((this as any).$moment().format('MM')) - 1;
            return this.months[curr];
        } 

        return this.months[this.fee.month - 1];
    }

    get nextMonth() {
        if (this.fee == null) return this.months[0];

        let month = this.fee.month - 1;
        if (this.fee.published && month <= 10) month++;
        return this.months[month];
    }

    /***** fields events *****/
    columns(group: string) {
        let cols = [{ value: 'concept_name', text: group.toUpperCase(), type: 'text', sortable: false, align: 'start', width: '280px', class: '' }];

        this.months.forEach(m => {
            let cClass = (this.fee != null && m.field == ('month_' + this.fee.month) ? 'selected-month' : '');
            if (this.fee != null && this.fee.published && this.fee.month == 12) cClass = '';
            cols.push({ value: m.field, text: m.name, type: 'text', width: '85px', sortable: false, align: 'center', class: cClass });
        });
        cols.push({ value: 'total', text: 'TOTAL', type: 'text', width: '65px', sortable: false, align: 'center', class: '' });
        return cols;
    }
    
    setList() {
        this.listValues = [];
        this.groups.forEach(gru => {
            this.listValues[gru.id] = [];

            this.list.forEach(item => {
                if (item.group_id == gru.id)
                    this.listValues[gru.id].push(item);
            });
        });            
    }

    updateTotal(item) {
        this.changed = true;
        item.total = 0;
        this.months.forEach(m => {
            item.total += (item[m.field] == null || item[m.field] == '' ? 0 : parseFloat(item[m.field]));
        });
        this.setTotals();
    }

    setTotals() {
        this.totals = [];
        this.groups.forEach(gru => {
            this.totals[gru.id] = {total: 0};

            this.months.forEach(m => {
                this.totals[gru.id][m.field] = 0;
            });

            if (this.listValues[gru.id] != undefined) {
                this.listValues[gru.id].forEach(item => {
                    this.months.forEach(m => {
                        this.totals[gru.id][m.field] += parseFloat((item[m.field] != undefined && item[m.field] != '' ? item[m.field] : 0));
                    });
                });

                this.months.forEach(m => {
                    this.totals[gru.id][m.field] = parseFloat(this.totals[gru.id][m.field].toFixed(2));
                    this.totals[gru.id].total += this.totals[gru.id][m.field];

                    this.totals[gru.id][m.field] = parseFloat((this.totals[gru.id][m.field]/4).toFixed(2));
                });

                this.totals[gru.id].total /= 4;
            }

            this.totals[gru.id].total = parseFloat(this.totals[gru.id].total.toFixed(2));
        });
    }

    getInitials(string) {
        return Util.getInitials(string);
    }

    onFocus(e) {
        e.target.select();
    }

    async exportData() {
        let filename = await this.$store.dispatch({
            type: 'fee/export',
            data: {
                year: this.period,
                dealer: this.dealer,
                red: this.red,
            }
        });
        if (filename != '' && filename != undefined)
            window.location = filename;
    }

    async create() {
        
        await this.$store.dispatch({
            type: 'fee/create',
            data: {
                dealer_id: this.dealer,
                year: this.period,
                month: this.nextMonth.id
            }
        });
        await this.loadData();
    }

    async save() {
        let data = [];
        this.months.forEach((m, i) => {
            data[i] = {
                id: null,
                dealer_id: this.dealer,
                year: this.period,
                month: m.id,
                concepts: []
            };

            this.list.forEach(f => {
                if (f['month_' + m.id] != null && f['month_' + m.id] != '') {
                    data[i].concepts.push({
                        concept_id: f.concept_id,
                        year: this.period,
                        month: m.id,
                        amount: f['month_' + m.id]
                    });
                }
            });
        });
        
        await this.$store.dispatch({
            type: 'fee/updateBatch',
            data: data
        });
        await this.loadData();
    }

    async loadData() {
        await this.$store.dispatch({
            type: 'fee/getAll',
            data: {
                year: this.period,
                dealer: this.dealers,
                red: this.red,
            }
        });
        this.setList();
        this.setTotals();
    }

    async mounted() {
        await this.loadData();
    }

    async created() {
    }
}
